import { cloneElement } from 'react';

import { ReactComponent as ArchiveIcon } from '../../icons/archive.svg';
import { ReactComponent as ArrowDownIcon } from '../../icons/arrow-down.svg';
import { ReactComponent as ArrowLeftIcon } from '../../icons/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../icons/arrow-right.svg';
import { ReactComponent as ArrowUpIcon } from '../../icons/arrow-up.svg';
import { ReactComponent as CheckIcon } from '../../icons/check.svg';
import { ReactComponent as CreateIcon } from '../../icons/create.svg';
import { ReactComponent as DeleteIcon } from '../../icons/delete.svg';
import { ReactComponent as ExitIcon } from '../../icons/exit.svg';
import { ReactComponent as HomeFilledIcon } from '../../icons/home-filled.svg';
import { ReactComponent as HomeIcon } from '../../icons/home.svg';
import { ReactComponent as InIcon } from '../../icons/in.svg';
import { ReactComponent as LinkIcon } from '../../icons/link.svg';
import { ReactComponent as MoreIcon } from '../../icons/more.svg';
import { ReactComponent as OutIcon } from '../../icons/out.svg';
import { ReactComponent as PinIcon } from '../../icons/pin.svg';
import { ReactComponent as ReplyIcon } from '../../icons/reply.svg';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as SettingsFilledIcon } from '../../icons/settings-filled.svg';
import { ReactComponent as SettingsIcon } from '../../icons/settings.svg';
import { ReactComponent as StateClosedIcon } from '../../icons/state-closed.svg';
import { ReactComponent as StateIcon } from '../../icons/state.svg';
import { ReactComponent as TopicIcon } from '../../icons/topic.svg';
import { ReactComponent as UpdateIcon } from '../../icons/update.svg';

import { ReactComponent as OldArchiveIcon } from '../../icons/old/archive.svg';
import { ReactComponent as OldArrowDownIcon } from '../../icons/old/arrow-down.svg';
import { ReactComponent as OldArrowLeftIcon } from '../../icons/old/arrow-left.svg';
import { ReactComponent as OldArrowRightIcon } from '../../icons/old/arrow-right.svg';
import { ReactComponent as OldArrowUpIcon } from '../../icons/old/arrow-up.svg';
import { ReactComponent as OldCheckIcon } from '../../icons/old/check.svg';
import { ReactComponent as OldCreateIcon } from '../../icons/old/create.svg';
import { ReactComponent as OldDeleteIcon } from '../../icons/old/delete.svg';
import { ReactComponent as OldExitIcon } from '../../icons/old/exit.svg';
import { ReactComponent as OldHomeFilledIcon } from '../../icons/old/home-filled.svg';
import { ReactComponent as OldHomeIcon } from '../../icons/old/home.svg';
import { ReactComponent as OldInIcon } from '../../icons/old/arrow-right.svg';
import { ReactComponent as OldLinkIcon } from '../../icons/old/link.svg';
import { ReactComponent as OldMoreIcon } from '../../icons/old/more.svg';
import { ReactComponent as OldOutIcon } from '../../icons/old/arrow-left.svg';
import { ReactComponent as OldPinIcon } from '../../icons/old/pin.svg';
import { ReactComponent as OldReplyIcon } from '../../icons/old/reply.svg';
import { ReactComponent as OldSearchIcon } from '../../icons/old/search.svg';
import { ReactComponent as OldSettingsFilledIcon } from '../../icons/old/settings-filled.svg';
import { ReactComponent as OldSettingsIcon } from '../../icons/old/settings.svg';
import { ReactComponent as OldStateClosedIcon } from '../../icons/old/state-closed.svg';
import { ReactComponent as OldStateIcon } from '../../icons/old/state.svg';
import { ReactComponent as OldTopicIcon } from '../../icons/old/topic.svg';
import { ReactComponent as OldUpdateIcon } from '../../icons/old/update.svg';

const newIcons = {
  archive: <ArchiveIcon />,
  'arrow-down': <ArrowDownIcon />,
  'arrow-left': <ArrowLeftIcon />,
  'arrow-right': <ArrowRightIcon />,
  'arrow-up': <ArrowUpIcon />,
  check: <CheckIcon />,
  create: <CreateIcon />,
  delete: <DeleteIcon />,
  exit: <ExitIcon />,
  'home-filled': <HomeFilledIcon />,
  home: <HomeIcon />,
  in: <InIcon />,
  link: <LinkIcon />,
  more: <MoreIcon />,
  out: <OutIcon />,
  pin: <PinIcon />,
  reply: <ReplyIcon />,
  search: <SearchIcon />,
  'settings-filled': <SettingsFilledIcon />,
  settings: <SettingsIcon />,
  'state-closed': <StateClosedIcon />,
  state: <StateIcon />,
  topic: <TopicIcon />,
  update: <UpdateIcon />,
};

const oldIcons = {
  archive: <OldArchiveIcon />,
  'arrow-down': <OldArrowDownIcon />,
  'arrow-left': <OldArrowLeftIcon />,
  'arrow-right': <OldArrowRightIcon />,
  'arrow-up': <OldArrowUpIcon />,
  check: <OldCheckIcon />,
  create: <OldCreateIcon />,
  delete: <OldDeleteIcon />,
  exit: <OldExitIcon />,
  'home-filled': <OldHomeFilledIcon />,
  home: <OldHomeIcon />,
  in: <OldInIcon />,
  link: <OldLinkIcon />,
  more: <OldMoreIcon />,
  out: <OldOutIcon />,
  pin: <OldPinIcon />,
  reply: <OldReplyIcon />,
  search: <OldSearchIcon />,
  'settings-filled': <OldSettingsFilledIcon />,
  settings: <OldSettingsIcon />,
  'state-closed': <OldStateClosedIcon />,
  state: <OldStateIcon />,
  topic: <OldTopicIcon />,
  update: <OldUpdateIcon />,
};

const Icon = ({ name, ...props }) => {
  const a11yAndPassedProps = {
    ...props,
    'aria-hidden': true,
    focusable: false,
  };

  if (JSON.parse(localStorage.getItem('featureFlags'))?.newIcons) {
    return cloneElement(newIcons[name], a11yAndPassedProps);
  } else {
    return cloneElement(oldIcons[name], a11yAndPassedProps);
  }
};

export default Icon;
